import DefaultUser from '../assets/images/user-default.png'
import dateFormat from 'dateformat';

export const modifyDate = (created_at: any) => {
  let date = dateFormat(created_at,"d mmmm, yyyy")
  return date;
}

export const customFormat = (iso : any) => {
  const d = new Date(iso);
  return d.toLocaleString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export const getAuth = () => {
  const storedToken = localStorage.getItem("user-data");
  let auth: any | null = null;
  if (storedToken) {
    try {
      auth = JSON.parse(storedToken);
    } catch (error) {
      console.error("Invalid token format in localStorage:", error);
      auth = null;
    }
  }
  return auth;
};
export const renderFormData  = async (values: any) => {
  var formData = new FormData();

  Object.keys(values).map(function (key, index) {
      console.log(` ${key} :`, index);
      if(key=="group_image" || key=="image" || key=="icon" || key=="normal_map" || key=="base_map"){
        formData.append(key, values[key][0])
      } else if ( key == "file"){
        formData.append(key, values[key])
      }else{
        formData.append(key, values[key])
      }
  });
  return formData
}

export const encodeID = (id: number) => {
  return id;
}
export const decodeID = (id: number) => {
  return id;
}

export const userPicUrl = (url: any) => {
  const PUrl = url?url:DefaultUser;
  return PUrl;
}
export const truncateText = (text : string, length: number) => {
  if (!text) return "";
  return text.length > length ? text.substring(0, length) + "..." : text;
};